import { useTranslation } from 'react-i18next'

import {
  ArrowCounterClockwiseIcon,
  ArrowSquareOutIcon,
  ArrowUDownLeftIcon,
  CheckCircleIcon,
  CoinsIcon,
  DotsThreeCircleVerticalIcon,
  EnvelopeIcon,
  PauseCircleIcon,
  PencilSimpleIcon,
} from '@phosphor-icons/react'

import { ButtonMenu, GiftCardIcon, IconButton, StoreCreditIcon } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionDetailMenu = ({
  onCancelStoreCredit,
  onCancelGiftCard,
  onIssueRefund,
  disabledIssueRefund,
  onPutRefundOnHold,
  allowPutRefundOnHold,
  onAmendRejected,
  disabledAmendRejected,
  allowsResendPaymentLink,
  onResendPaymentLink,
  allowRevertCancelStatus,
  disabledRevertCancelStatus,
  onRevertCancelStatus,
  customersUrl,
  onClickCustomersUrl,
  onSwitchExchangeToRefund,
  allowSwitchExchangeToRefund,
  onMarkAsIssued,
  allowMarkAsIssued,
  allowCancelStoreCredit,
  allowCancelGiftCard,
  onMarkAsPaid,
  allowMarkAsPaid,
}) => {
  const { t } = useTranslation()

  const options = [
    {
      label: (
        <Styles.MenuOptionLabel>
          <StoreCreditIcon size={16} type="slashed" />
          {t('Anular crédito en tienda')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onCancelStoreCredit,
      disabled: false,
      visible: allowCancelStoreCredit && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <GiftCardIcon size={16} type="slashed" />
          {t('Anular tarjeta regalo')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onCancelGiftCard,
      disabled: false,
      visible: allowCancelGiftCard && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <CoinsIcon />
          {t('Emitir reembolso')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onIssueRefund,
      disabled: disabledIssueRefund,
      visible: !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <PauseCircleIcon />
          {t('Poner reembolso en espera')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onPutRefundOnHold,
      disabled: false,
      visible: allowPutRefundOnHold && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <PencilSimpleIcon />
          {t('Corregir rechazados')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onAmendRejected,
      disabled: disabledAmendRejected,
      visible: !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <EnvelopeIcon />
          {t('Reenviar link de pago')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onResendPaymentLink,
      disabled: false,
      visible: allowsResendPaymentLink && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <ArrowCounterClockwiseIcon />
          {t('Revertir estado cancelado')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onRevertCancelStatus,
      disabled: disabledRevertCancelStatus,
      visible: allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <ArrowSquareOutIcon />
          {t('Ver en el portal del cliente')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onClickCustomersUrl,
      disabled: false,
      visible: customersUrl && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <ArrowUDownLeftIcon />
          {t('Convertir cambio en devolución')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onSwitchExchangeToRefund,
      disabled: false,
      visible: allowSwitchExchangeToRefund && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <CheckCircleIcon />
          {t('Marcar como emitido')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onMarkAsIssued,
      disabled: false,
      visible: allowMarkAsIssued && !allowRevertCancelStatus,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <CheckCircleIcon />
          {t('Marcar como pagado')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onMarkAsPaid,
      disabled: false,
      visible: allowMarkAsPaid && !allowRevertCancelStatus,
    },
  ]

  return (
    <ButtonMenu
      menuItems={options.filter(o => o.visible)}
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon data-testid="menuButton" size={24} />}
        />
      )}
    />
  )
}

export default TransactionDetailMenu
